import React from "react";
import { useNavigate } from "react-router-dom";
import ProductCogs from "./ProductCogs";

type SettingsSection = "product-cogs";

const SECTIONS: { id: SettingsSection; label: string; path: string }[] = [
  { id: "product-cogs", label: "Product COGS", path: "/unit-economics/product-cogs" },
];

const Settings: React.FC = () => {
  const navigate = useNavigate();

  const activeSection: SettingsSection = "product-cogs";

  return (
    <div className="space-y-6">
      <div className="flex gap-1 border-b border-gray-200 pb-0">
        {SECTIONS.map((section) => {
          const active = activeSection === section.id;
          return (
            <button
              key={section.id}
              onClick={() => navigate(section.path)}
              className={`flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium rounded-t-lg border transition-colors -mb-px ${active
                ? "bg-white border-gray-200 border-b-white text-gray-800"
                : "bg-transparent border-transparent text-gray-500 hover:text-gray-700"
                }`}
            >
              {section.id === "product-cogs" && (
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                </svg>
              )}
              {section.label}
            </button>
          );
        })}
      </div>

      <div>
        {activeSection === "product-cogs" && <ProductCogs />}
      </div>
    </div>
  );
};

export default Settings;
